<template>
  <div>
    <v-row>
      <v-col cols="12" v-if="showTitle">
        <v-toolbar class="mb-2 pa-0" color="primary" dark flat>
          <v-toolbar-title>{{ grafTitle }}</v-toolbar-title>
        </v-toolbar>
      </v-col>
    </v-row>
    <v-row align="center">
      <v-col v-if="showMetody" cols="12">
        <v-row>
          <template v-for="mer in merania">
            <v-col md="4" sm="12" class="ma-0 pa-0" :key="mer">
              <v-checkbox
                v-model="filterMerania"
                :label="getDescription(mer)"
                :value="mer"
                class="ma-0 pa-0 pl-2"
                dense
                hide-details
                :disabled="isLokalita && !getMeranieCount(mer) > 0"
                @change="show()"
              ></v-checkbox>
            </v-col>
          </template>
        </v-row>
      </v-col>
    </v-row>
    <v-row v-if="isHorizontalBar">
      <v-col
        cols="12"
        v-show="grafHeaders.length > 0"
        :id="'grafContainer' + typ"
      >
        <horizontal-bar-chart
          :chart-data="grafValues"
          :options="grafOptions"
        ></horizontal-bar-chart>
      </v-col>
    </v-row>
    <v-row v-if="isBar">
      <v-col cols="12" :id="'grafContainer' + typ">
        <bar-chart :chart-data="grafValues" :options="grafOptions"></bar-chart>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import * as Enums from "../plugins/enums.js"
//import * as moment from "moment"
import HorizontalBarChart from "../components/charts/HorizontalBarChart.js"
import BarChart from "../components/charts/BarChart.js"
import * as Colors from "../plugins/colors.js"
import Vue from "vue"

export default {
  data: function () {
    return {
      loading: false,
      grafHeaders: [],
      grafData: [],
      merania: [
        Enums.TYPY.DILAT,
        Enums.TYPY.GEO,
        Enums.TYPY.HPV,
        Enums.TYPY.INKP,
        Enums.TYPY.INKS,
        Enums.TYPY.MIKRO,
        Enums.TYPY.PEEP,
        Enums.TYPY.PEES,
        Enums.TYPY.POTRUB,
        Enums.TYPY.PRNA,
        Enums.TYPY.PT,
        Enums.TYPY.HPVQ,
        Enums.TYPY.STAB,
      ],
      filterMerania: [],
    }
  },
  components: { BarChart, HorizontalBarChart },
  props: {
    typ: {
      type: String,
      required: true,
    },
    lokalita: {
      type: Object,
      required: false,
      default: function () {
        return {}
      },
    },
    stanica: {
      type: Object,
      required: false,
      default: null,
    },
  },
  computed: {
    isHorizontalBar: function () {
      let ret = true
      return ret
    },
    isBar: function () {
      let ret = false
      return ret
    },
    showTitle: function () {
      let ret = false
      if (this.typ === "monitor") {
        ret = true
      }
      if (this.typ === "zrazky") {
        ret = true
      }
      return ret
    },
    isLokalita: function () {
      return this.lokalita.ID !== undefined
    },
    showMetody: function () {
      let ret = false
      if (this.typ === "monitor") {
        ret = true
      }
      if (this.typ === "monitorLokalita") {
        ret = true
      }
      return ret
    },
    grafTitle: function () {
      let ret = ""
      if (this.typ === "monitor") {
        ret = "Graf - Monitorovanie jednotlivých ukazovateľov"
      }
      if (this.typ === "zrazky") {
        ret = "Graf - Monitorovanie zberu údajov zo staníc SHMÚ"
      }
      return ret
    },
    grafValues: function () {
      let ret = ""
      switch (this.typ) {
        case "monitor":
        case "monitorLokalita":
        case "zrazky":
          ret = {
            labels: this.grafHeaders,
            datasets: [
              {
                backgroundColor: Colors.defaultColors(),
                borderColor: "black",
                borderWidth: 0,
                barThickness: 16,
                maxBarThickness: 16,
                data: this.grafData,
              },
            ],
          }
          break
        default:
          break
      }
      return ret
    },
    grafOptions: function () {
      let ret = ""
      switch (this.typ) {
        case "monitor":
        case "monitorLokalita":
        case "zrazky":
          ret = {
            maintainAspectRatio: false,
            responsive: true,
            legend: { display: false },
          }
          break
        default:
          break
      }
      return ret
    },
    urlFetch: function () {
      let url = "/r/chart/" + this.typ
      if (this.typ === "monitor") {
        url += "?metody=" + this.filterMerania.toString()
      }
      if (this.typ === "monitorLokalita") {
        url += "?metody=" + this.filterMerania.toString()
        url += "&lokalitaID=" + this.lokalita.ID
      }
      return url
    },
  },
  methods: {
    show: async function () {
      try {
        console.log("Chart.vue, show")
        this.grafData = []
        this.grafHeaders = []
        this.loading = true
        let response = await this.$axios.get(this.urlFetch)
        this.loading = false
        if (response.status === 200) {
          this.grafData = response.data.data
          this.grafHeaders = response.data.headers
          //this.grafData = this.grafData.concat(this.grafData)
          //this.grafHeaders = this.grafHeaders.concat(this.grafHeaders)
          if (this.grafData === null) {
            this.grafData = []
          }
          if (this.grafHeaders === null) {
            this.grafHeaders = []
          }
          let c = document.querySelector(`div#grafContainer${this.typ} canvas`)
          let newSize = this.grafData.length * 20
          newSize = Math.max(newSize, 400)
          c.style.height = newSize + "px"
        } else {
          this.$store.commit("alert", response.data.Error)
        }
      } catch (error) {
        this.loading = false
        this.$store.commit("alert", error.toString())
      }
    },
    getDescription: function (mer) {
      return Enums.getDescription(mer)
    },
    getMeranieCount(mer) {
      const countItem = Enums.getMeranieCountItem(this.lokalita, mer)
      return countItem.pocet
    },
  },
  mounted: async function () {
    await this.$store.dispatch("fetchme", this.$axios)
    this.filterMerania = this.merania
    Vue.nextTick(() => {
      this.show()
    })
  },
}

/*
//Download Chart Image
document.getElementById("download").addEventListener('click', function(){
  var url_base64jp = document.getElementById("lineChart").toDataURL("image/jpg");
  var a =  document.getElementById("download");
  a.href = url_base64jp;
});
*/
</script>
